import { AgGridService } from "@topline/services/agGridService";
import { angularServicesNames } from "@topline/services/angularServicesNames";

(function (module) {
    "use strict";

    module.component('brandGroupName', {
        template: require('./brandGroupNameComponent.html'),
        controller: ['$scope', '$uibModal', 'brandGroupNameService', angularServicesNames.$translate, AgGridService.componentName,'AlertService',
            function(
                this: $TSFixMe,
                $scope: $TSFixMe,
                $uibModal: ng.ui.bootstrap.IModalService,
                brandGroupNameService: $TSFixMe,
                $translate: ng.translate.ITranslateService,
                agGridService: AgGridService,
                AlertService: AlertService
            ) {
                var $ctrl = this;
                $scope.model = {};
                $scope.$on('LanguageChanged', () => agGridService.refreshGridLanguage($ctrl.gridApi));

                $ctrl.gridOptions = {
                    columnDefs: [
                        {
                            headerValueGetter: () => $translate.instant("CONFIGURATION.BRAND_GROUP_NAME.NAME"),
                            field: "name"
                        },
                        {
                            headerValueGetter: () => $translate.instant("ACTIONS"),
                            cellRenderer: () =>
                                `<div  class="ui-grid-cell-contents">
                                    <a href="#" ng-click="$ctrl.actions.edit(data)"><i class="glyphicon glyphicon-edit"></i></a>
                                    <a href="#" ng-click="$ctrl.actions.remove(data)"><i class="glyphicon deactivate-icon glyphicon-remove-circle"></i></a>
                                </div>`,
                            sortable: false,
                            suppressMenu: true
                        }
                    ],
                    domLayout: 'autoHeight',
                    angularCompileRows: true,
                    defaultColDef: { 
                        sortable: true,
                        resizable: true
                     },
                    enableFilter: false,
                    animateRows: true,
                    pagination: true,
                    paginationPageSize: 15,
                    localeTextFunc: agGridService.transalteFunc,
                    suppressHorizontalScroll: true,
                    onGridReady: (config: $TSFixMe) => {
                        $ctrl.gridApi = config.api;
                        config.api.sizeColumnsToFit();
                        loadData();
                    },
                    onGridSizeChanged: (config: $TSFixMe) => {
                        config.api.sizeColumnsToFit();
                    }
                }

                $ctrl.actions = {
                    edit: function (entity: $TSFixMe) {
                        var modalInstance = $uibModal.open({
                            component: 'brandGroupNameEdit',
                            resolve: {

                                model: () => angular.copy(entity),
                                options: () => "edit"
                            }
                        });
                        modalInstance.result.then((response: $TSFixMe) => {
                            brandGroupNameService.edit(response).
                                then((response: $TSFixMe) => {
                                    if (response.status == HttpStatus.OK || response.status == 204) {
                                        loadData();
                                    } else {
                                        errorHandler(response)
                                    }
                                }, () => { });
                        });
                    },
                    add: function () {
                        var modalInstance = $uibModal.open({
                            component: 'brandGroupNameEdit',
                            resolve: {
                                model: () => { },
                                options: () => "add"
                            }
                        });
                        modalInstance.result.then((response: $TSFixMe) => {
                            brandGroupNameService.add(response).
                                then((response: $TSFixMe) => {
                                    if (response.status == HttpStatus.OK || response.status == 204) {
                                        loadData();
                                    } else {
                                        errorHandler(response)
                                    }
                                }, () => { });
                        });
                    },
                    remove: function (entity: $TSFixMe) {
                        brandGroupNameService.remove(entity)
                            .then(() => loadData());
                    }
                }

                function loadData() {
                    brandGroupNameService.get().then((items: $TSFixMe) => {
                        $ctrl.gridApi.setRowData(items);
                    });
                }

                const errorHandler = (err: $TSFixMe) => {
                    switch (err.status) {
                        case HttpStatus.Conflict:
                            AlertService.error($translate.instant('CONFIGURATION.BRAND_GROUP_NAME.NAME_NOT_UNIQUE'));
                            break;
                    }
                }
            }]
    });

}(angular.module('topline.modules')));